var passwordFields = document.querySelectorAll('input[type="password"]');
var toggleButtons = document.getElementsByClassName('show-password');

for (var i = 0; i < toggleButtons.length; i++) {
  toggleButtons[i].addEventListener('click', function() {
    var passwordField = this.previousElementSibling;
    var eyyOffLine    = this.querySelector('#eye-off-line');
    var eyyOnLine     = this.querySelector('#eye-on-line');

    if (passwordField.type === 'password') {
      passwordField.type = 'text';

      eyyOnLine.classList.remove('d-none');
      eyyOffLine.classList.add('d-none');
    } else {
      passwordField.type = 'password';

      eyyOnLine.classList.add('d-none');
      eyyOffLine.classList.remove('d-none');
    }
  });
}